<template>
  <div class="system-panel">
    <div class="system-tabs">
      <button class="system-tab" :class="{ active: activeTab === 'geral' }" type="button" @click="activeTab = 'geral'">Geral</button>
      <button class="system-tab" :class="{ active: activeTab === 'presencas' }" type="button" @click="activeTab = 'presencas'">Presenças</button>
      <button class="system-tab" :class="{ active: activeTab === 'atividades' }" type="button" @click="activeTab = 'atividades'">Log de atividades</button>
      <button class="system-tab" :class="{ active: activeTab === 'offline' }" type="button" @click="activeTab = 'offline'">Tempo Offline</button>
      <button class="system-tab" :class="{ active: activeTab === 'relatorios' }" type="button" @click="activeTab = 'relatorios'">Cores dos relatórios</button>
      <button class="system-tab" :class="{ active: activeTab === 'fuso' }" type="button" @click="activeTab = 'fuso'">Fuso horário</button>
      <button class="system-tab" :class="{ active: activeTab === 'armazenamento' }" type="button" @click="activeTab = 'armazenamento'">Armazenamento</button>
      <button v-if="isMasterAdmin" class="system-tab" :class="{ active: activeTab === 'recursos' }" type="button" @click="activeTab = 'recursos'">Recursos</button>
    </div>

    <SystemTabGeral
      v-if="activeTab === 'geral'"
      :form="form"
      :error-text="errorText"
      :success-text="successText"
      @update-form="$emit('update-form', $event)"
      @save="$emit('save')"
    />

    <SystemTabPresencas
      v-if="activeTab === 'presencas'"
      :form="form"
      :error-text="errorText"
      :success-text="successText"
      @update-form="$emit('update-form', $event)"
      @save="$emit('save')"
    />

    <SystemTabAtividades v-if="activeTab === 'atividades'" />

    <SystemTabOffline
      v-if="activeTab === 'offline'"
      :form="form"
      :error-text="errorText"
      :success-text="successText"
      @update-form="$emit('update-form', $event)"
      @save="$emit('save')"
    />

    <SystemTabCoresRelatorios
      v-if="activeTab === 'relatorios'"
      :form="form"
      :error-text="errorText"
      :success-text="successText"
      @update-form="$emit('update-form', $event)"
      @save="$emit('save')"
    />

    <SystemTabFuso
      v-if="activeTab === 'fuso'"
      :form="form"
      :error-text="errorText"
      :success-text="successText"
      @update-form="$emit('update-form', $event)"
      @save="$emit('save')"
    />

    <SystemTabArmazenamento v-if="activeTab === 'armazenamento'" />

    <SystemTabRecursos
      v-if="isMasterAdmin && activeTab === 'recursos'"
      :form="form"
      :error-text="errorText"
      :success-text="successText"
      @update-form="$emit('update-form', $event)"
      @save="$emit('save')"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'
import SystemTabGeral from './system-panel/SystemTabGeral.vue'
import SystemTabPresencas from './system-panel/SystemTabPresencas.vue'
import SystemTabAtividades from './system-panel/SystemTabAtividades.vue'
import SystemTabOffline from './system-panel/SystemTabOffline.vue'
import SystemTabCoresRelatorios from './system-panel/SystemTabCoresRelatorios.vue'
import SystemTabFuso from './system-panel/SystemTabFuso.vue'
import SystemTabArmazenamento from './system-panel/SystemTabArmazenamento.vue'
import SystemTabRecursos from './system-panel/SystemTabRecursos.vue'

type TabId = 'geral' | 'presencas' | 'atividades' | 'offline' | 'relatorios' | 'fuso' | 'armazenamento' | 'recursos'

export default defineComponent({
  name: 'SystemPanel',
  components: { SystemTabGeral, SystemTabPresencas, SystemTabAtividades, SystemTabOffline, SystemTabCoresRelatorios, SystemTabFuso, SystemTabArmazenamento, SystemTabRecursos },
  props: {
    form: { type: Object, required: true },
    errorText: { type: String, default: '' },
    successText: { type: String, default: '' },
    initialTab: { type: String, default: 'geral' },
    isMasterAdmin: { type: Boolean, default: false },
  },
  emits: ['update-form', 'save'],
  setup(props) {
    const activeTab = ref<TabId>((props.initialTab as TabId) || 'geral')
    watch(() => props.initialTab, (v: string) => { if (v) activeTab.value = v as TabId })
    return { activeTab }
  }
})
</script>

<style scoped lang="scss">
.system-panel { display: flex; flex-direction: column; gap: 16px; }
.system-tabs { display: flex; gap: 8px; flex-wrap: wrap; }
.system-tab {
  border: 1px solid rgba(31,30,26,.12);
  background: rgba(255,255,255,.9);
  color: var(--ink-muted);
  border-radius: 999px;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: all .15s ease;
  &.active { background: var(--accent); border-color: var(--accent); color: #fff; }
}
</style>
